<template>
    <div class="controlSet">
        <page-header></page-header>
        <div class="set-option">
            <template>
                <el-select class="charts-input" v-model="option.sys_alias" @change="changeOption(true)"
                           placeholder="请选择">
                    <el-option v-for="item in sys_alias" :key="item.id" :label="item.label" :value="item.val">
                    </el-option>
                </el-select>
            </template>
            <div class="charts-input">
                <el-button type='primary' :loading="loading" @click="changeOption(false)">{{loading ? '正在加载' : '手动刷新'}}</el-button>
            </div>
        </div>
        <div class="css-margin-top">
            <el-card class="box-card" body-style="{min-height:'300px'}">
                <loading v-if="loading"></loading>
                <template v-else>
                    <div class="clearfix chars-header">
                        <span class="card-header-title">参数设置</span>
                        <div class="time-show">
                            {{option.time_stamp}}
                        </div>
                        <div>
                            <el-button v-show="!option.isEdit" type='text' @click="openEdit">编辑</el-button>
                            <el-button v-show="option.isEdit" @click="closeEdit" type="text">取消</el-button>
                            <el-button @click="saveDeviceConf" :loading="loading" v-show="option.isEdit" type="success">
                                {{loading ? '正在加载' : '保存并写入设备'}}
                            </el-button>
                        </div>
                    </div>
                    <!-- TODO 更好的表单验证方式 -->
                    <div v-if="!isMobile" class="table-list">
                        <template>
                            <el-table :data="confData.slice(0,Math.round(confData.length/2))" class="val-table">
                                <el-table-column prop="name" label="参数名">
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p v-if="!option.isEdit">{{scope.row.data}}</p>
                                            <el-input-number v-else v-model="scope.row.data" :disabled="!option.isEdit"
                                                             @change="checkInputNumber(scope.row.data,scope.$index)"
                                                             :precision="scope.row.prec"
                                                             :step="scope.row.step"
                                                             :min="scope.row.min"
                                                             :max="scope.row.max"></el-input-number>
                                        </div>
                                    </template>

                                </el-table-column>

                            </el-table>
                        </template>

                        <template>
                            <el-table :data="confData.slice(Math.round(confData.length/2))" class="val-table">
                                <el-table-column prop="name" label="参数名">
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p v-if="!option.isEdit">{{scope.row.data}}</p>
                                            <el-input-number v-else  v-model="scope.row.data"
                                                             @change="checkInputNumber(scope.row.data,scope.$index)"
                                                             :min="scope.row.min"
                                                             :precision="scope.row.prec"
                                                             :step="scope.row.step"
                                                             :max="scope.row.max"></el-input-number>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>

                    <!-- isMobile table -->

                    <div v-if="isMobile" class="table-list">
                        <template>
                            <el-table :data="confData" class="mobile-val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <p style="font-size:14px">{{scope.row.name}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p v-if="!option.isEdit">{{scope.row.data}}</p>
                                            <el-input v-else size="small" v-model="scope.row.data"
                                                             @change="checkInputNumber(scope.row.data,scope.$index)"
                                                             :precision="scope.row.prec"
                                                             :step="scope.row.step"
                                                             :min="scope.row.min"
                                                             :max="scope.row.max"></el-input>
                                        </div>
                                    </template>

                                </el-table-column>

                            </el-table>
                        </template>

                    </div>
                </template>

            </el-card>

        </div>

    </div>
</template>

<script>
    import {
        mapState
    } from "vuex";
    import Lib from "../../lib/lib.js";
    import pageHeader from "../../components/tempControl/header";
    import loading from "../../components/common/loading";
    import _ from "lodash";

    export default {
        name: "controlSet",
        components: {
            pageHeader,
            loading
        },
        data() {
            return {
                option: {
                    sys_alias: "",
                    isEdit: false,
                    time_stamp: ""
                },
                test: "",
                loading: "",
                sys_alias: [],
                val: "",
                confData: [],
                floatDataIndexStart: 24, 
                floatDataIndexEnd: 45, 
                isRepeat:false,
                id_of_setinterval:''
            };
        },
        computed: mapState({
            isMobile: state => state.isMobile,
            deviceInfo: state => state.deviceInfo,
            userInfo: state => state.userInfo,
            config: state => state.config
        }),
        created() {
            this.creatAliasMeun(this.deviceInfo.alias_m);
            this.option.sys_alias = "1";
        },
        mounted() {
            for (let i = 0; i < 1; i++) {
                this.changeOption(true);
                Lib.M.selectInputFoc();
            }
            this.timingLoad('OPEN')

        },
        beforeDestroy() {
            this.loading = false;
            this.timingLoad('CLOSE')
        },
        methods: {
            /**
             * 创建窑号选框
             * @argument MaxAlias 最大窑数
             */
            creatAliasMeun(MaxAlias) {
                for (let i = 0; i < MaxAlias; i++) {
                    this.sys_alias.push({
                        val: `${i + 1}`,
                        label: `${i + 1}号窑`
                    });
                }
            },
            changeOption(type){
                this.loading = true;
                this.confData = [];
                let that = this;
                this.loadDeviceSettings(type, (is_succ)=>{
                    that.loadControlConf(type);
                });
            },

            timingLoad(type){
                if (type === "OPEN") {
                    this.id_of_setinterval = setInterval(() => {
                        this.loadControlConf(false);
                    }, this.config.refreshInterval?this.config.refreshInterval:30000);
                } else {
                    clearInterval(this.id_of_setinterval);
                }
            },
            loadDeviceSettings(is_cache, callback){
                this.loading = true
                let params = {
                    sys_alias: this.option.sys_alias,
                    is_cache: is_cache,
                    device_id: this.deviceInfo.device_id
                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceSetting(params, (data) => {
                    if (data.payload && data.payload.data) {
                        try {
                            let jsonData = JSON.parse(data.payload.data);
                            delete jsonData.oother;
                            delete jsonData.isSuccess;
                            delete jsonData.msg;
                            console.log("device setting:", jsonData);
                            this.floatDataIndexStart = jsonData.zkcsUchar + jsonData.zkcsChar + jsonData.zkcsUint + jsonData.zkcsInt + jsonData.zkcsUlong + jsonData.zkcsLong;
                            this.floatDataIndexEnd = this.floatDataIndexStart+ jsonData.zkcsFloat;
                        } catch (err) {
                            console.log(err);
                        }
                        if(callback){
                            callback();
                        }
                    } else {
                        if (!is_cache) {
                            this.loadDeviceSettings(true, callback);
                        }else{
                            if(callback){
                                callback();
                            }
                        }
                    }
                });
            },
            loadControlConf(is_cache) {

                let params = {
                    conf_type: "control",
                    sys_alias: this.option.sys_alias,
                    device_id: this.deviceInfo.device_id,
                    is_cache: is_cache
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceConf(params, data => {
                    this.loading = false;
                    // 确认数据是否更新，否则只读
                    if (data.status_code === "SUCCEEDED") {

                    } else {
                        this.$message({
                            message: "网络连接超时：" + data.msg,
                            type: "warning"
                        });
                        if (!this.isMobile) {
                            this.$notify.info({
                                title: "温馨提示",
                                message: "无法连接设备时，无法进行参数修改操作",
                                duration: 3000,
                                offset: 60
                            });
                        }
                        this.closeEdit();
                        if(!this.isRepeat){
                            this.isRepeat=true
                            this.loadControlConf(false)
                        }
                    }
                    if (data.payload && data.payload.data) {
                        this.confData = this.dealDateFn(data, "load");
                        this.option.time_stamp = data.payload.time_stamp;
                    }
                });
            },
            saveDeviceConf() {
                this.loading = true;
                let payload = this.dealDateFn(this.confData, "post");
                if (payload == false) {
                    this.$message.error("参数错误");
                    return false;
                } else {
                    payload.devNo = this.option.sys_alias*1;
                    payload = JSON.stringify(payload);
                }
                let params = {
                    conf_type: "control",
                    sys_alias: this.option.sys_alias.toString(),
                    device_id: this.deviceInfo.device_id,
                    payload: payload
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                console.log(params);
                Lib.api.setDeviceConf(params, data => {
                    if (data.status_code === "SUCCEEDED") {
                        this.$message.success("修改成功");
                        this.loadControlConf(false);
                        this.closeEdit();
                    } else {
                        this.$message.error(`修改失败：${data.msg}`);
                        this.loading = false;
                    }
                });
            },
            // 处理获取到的配置数据
            dealDateFn(data, type) {
                let confData;
                if (type === "load") {
                    let jsonData = JSON.parse(data.payload.data);
                    confData = [];
                    if (jsonData.oother) {
                        delete jsonData.oother;
                        if (jsonData.msg) {
                            delete jsonData.msg;
                            delete jsonData.isSuccess;
                        }
                    }
                    this.test = jsonData;
                    let jsonDataIndex = 0;
                    for (let key in jsonData) {
                        if (jsonData.hasOwnProperty(key)) {
                            let item = jsonData[key], 
                                precision = 0,
                                step = 1, 
                                max,
                                min;
                            precision = Lib.M.getPrecision(item);
                            if (jsonDataIndex < 11) {
                                max = 255;
                                min = 0;
                            } else if (jsonDataIndex < this.floatDataIndexStart) {
                                max = 65565;
                                min = 0;
                            } else if (jsonDataIndex < this.floatDataIndexEnd) {
                                max = 35575;
                                min = -35575;

                                if (precision<=0){
                                    precision = 1;
                                    item = item.toFixed(precision);
                                    console.log(item, precision);
                                }
                            }
                            
                            step = Math.pow(0.1,precision);
                            confData.push({
                                name: key,
                                data: item,
                                prec: precision,
                                step: step,
                                max: max,
                                min: min
                            });
                        }
                        jsonDataIndex++;
                    }
                } else {
                    confData = {};
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (data[i].data === "") {
                            return false;
                        }
                        confData[item.name] = _.round(item.data, 2);
                        if (i < this.floatDataIndexStart) {
                            confData[item.name] = _.round(item.data);
                        }
                    }
                }
                console.log(confData);
                return confData;
            },
            // 检查输入是否是两位小数
            checkInputNumber(val, index) {
                // this.confData[index].data=_.round(val,2)
                // return _.round(val,2)
            },
            // 打开编辑
            openEdit() {
                if (this.userInfo.role === "manager" || this.userInfo.role === "admin") {
                  this.changeOption(false);
                  this.option.isEdit = true;
                  this.timingLoad('')
                } else {
                    this.$message.error("权限不足，修改失败");
                }
            },
            closeEdit() {
                this.option.isEdit = false;
              this.timingLoad('OPEN')
            }
        }
    };
</script>

<style scoped>
    .body-style {
        min-height: 300px;
    }

    .set-option {
        display: flex;
        justify-content: space-between;
    }

    .table-list {
        display: flex;
        width: 100%;
    }

    .el-card box-card {
        width: 100%;
    }

    .chars-header {
        font-size: 0.22rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.3rem;
    }

    .val-table {
        width: 50%;
    }

    .table-list .el-table__header-wrapper thead div {
        background: #71b7ff;
    }

    .scope-input {
        display: flex;
        align-items: center;
    }

    .scope-input > .el-input {
        flex: 1;
    }

    .scope-input > span {
        margin: 0 5px;
    }

    .edit-input {
        margin: 9px 0;
    }
</style>





// WEBPACK FOOTER //
// controlSet.vue?2f994650